import { UIManager } from "../../../core/UIManager";
import { APICallMethod, event, PlayerType, TrackingContentEvent } from "../../../utils/const";

import controls from '../html/stream-controls.html';
import {API} from "../../../utils/api";

export class StreamUIManager extends UIManager {
	constructor({ container, emitter, template, config, streamUIData, streamView, streamConfig }) {
		super({ container, emitter, template, config });
		
		this.streamUIData = streamUIData;
		this.streamConfig = streamConfig;
		this.streamView = streamView;
		this.video = null;
		
		this.init(this._template({
			controls: this._config.type === PlayerType.EMBED ? "" : controls()
		}));
		
		this._emitter.once(event.UI.HidePoster, () => {
			this.ui.streamPoster.classList.add("hidden");
			this._container.style.zIndex = '';
		});
		this._emitter.on(event.Stream.StreamBackgroundClicked, () => {
			this.streamView.classList.remove('vads-stream-slider');
			
			this._emitter.emit(event.Player.ResizeAllAds, { width: this._container.clientWidth, height: this._container.clientHeight });
		});
		this._emitter.once(event.Stream.BindStreamVideoToUI, this.bindVideoToUI);
	}
	
	showPoster = () => {
		this.ui.streamPoster.src = this.streamUIData.poster;
		this.ui.streamPoster.classList.remove('hidden');
		
		this._container.style.zIndex = 5;
	}
	
	// TODO: Вынести методы ниже в отдельный подкласс для стрима
	
	bindVideoToUI = (video) => {
		this.video = video;
		
		video.addEventListener('timeupdate', this.onTimeUpdate);
		video.addEventListener('pause', () => {
			this.ui.pause.style.display = 'none';
			this.ui.resume.style.display = 'block';
			
			this._emitter.emit(event.Player.ContentPaused);
		});
		video.addEventListener('play', () => {
			if (this._config.content.trackingEvents && this._config.content.trackingEvents.includes(TrackingContentEvent.START) && Math.round(this.video.currentTime) === 0) {
				API.call(this.streamConfig.streamTrackingUrls.start.replace('(cb)', Date.now()).replace('(content.id)', this.streamUIData.id), {}, {}, APICallMethod.IMAGE);
			}
			
			this.ui.resume.style.display = 'none';
			this.ui.pause.style.display = 'block';
			
			this._emitter.emit(event.Player.ContentResumed);
		});
		video.addEventListener('volumechange', (evt) => {
			this.ui.volumeProgress.style.setProperty('--vads-stream-volume-progress', `${this.video.volume * 100}%`);
			
			if (this.video.muted) {
				this.ui.volumeContainer.classList.add('vads-muted'); // TODO: вынести тоггл в функцию
				this.ui.volumeContainer.classList.remove('vads-unmuted');
			} else {
				this.ui.volumeContainer.classList.remove('vads-muted'); // TODO: вынести тоггл в функцию
				this.ui.volumeContainer.classList.add('vads-unmuted');
			}
		});
		this.video.addEventListener('ended', () => {
			if (this._config.content.trackingEvents && this._config.content.trackingEvents.includes(TrackingContentEvent.COMPLETE)) {
				API.call(this.streamConfig.streamTrackingUrls.complete.replace('(cb)', Date.now()).replace('(content.id)', this.streamUIData.id), {}, {}, APICallMethod.IMAGE);
			}
			
			this.video.currentTime = 0;
			this.video.play();
		});
		
		this.streamView.addEventListener('fullscreenchange', this.onFullscreenModeChanged);
		
		this.ui.resume.addEventListener('click', this.onResumeClick);
		this.ui.pause.addEventListener('click', this.onPauseClick);
		this.ui.mute.addEventListener('click', this.onMuteClick);
		this.ui.unmute.addEventListener('click', this.onUnMuteClick);
		this.ui.volumeProgress.addEventListener('click', this.onVolumeProgressClick);
		this.ui.streamTimeline.addEventListener('mousemove', this.onTimelineMouseMove);
		this.ui.streamTimeline.addEventListener('mouseleave', this.onTimelineMouseLeave)
		this.ui.streamTimeline.addEventListener('click', this.onTimelineClick);
		this.ui.enterFullscreen.addEventListener('click', this.onEnterFullscreenClick);
		this.ui.exitFullscreen.addEventListener('click', this.onExitFullscreenClick);
		this.ui.slider.addEventListener('click', this.onSliderModeClick);
	}
	
	onTimeUpdate = () => {
		const timelineProgress = this.video.currentTime / (this.video.duration * 0.01);
		
		const durationMinutes = this.video.duration ? Math.floor(this.video.duration / 60) : '-';
		const durationSeconds = this.video.duration ? Math.floor(this.video.duration % 60) : '-';
		
		this.ui.streamTimer.innerText = `${this.getFormattedCurrentTime(this.video.currentTime)} / ${durationMinutes}:${durationSeconds > 9 ? durationSeconds : '0' + durationSeconds}`;
		this.ui.streamTimeline.style.setProperty('--vads-stream-timeline-progress', `${timelineProgress}%`);
	}
	
	onTimelineMouseMove = (evt) => {
		const progress = this.getProgressPercentByOffsetWidth({ offset: evt.layerX, width: this.ui.streamTimeline.clientWidth });
		
		const rewindTime = Math.floor(this.video.duration / 100 * progress);
		
		this.ui.streamTimeline.style.setProperty('--vads-stream-timeline-shadow', `${progress}%`);
		this.ui.streamRewindTime.innerText = this.getFormattedCurrentTime(rewindTime);
	}
	
	onTimelineMouseLeave = () => this.ui.streamTimeline.style.setProperty('--vads-stream-timeline-shadow', `0%`);
	
	onTimelineClick = (evt) => {
		evt.stopPropagation();
		
		const progress = this.getProgressPercentByOffsetWidth({ offset: evt.layerX, width: this.ui.streamTimeline.clientWidth });
		this.video.currentTime = progress * (this.video.duration / 100);
	}
	
	onPauseClick = (evt) => {
		evt && evt.stopPropagation();
		
		this.video.pause();
	}
	
	onResumeClick = (evt) => {
		evt && evt.stopPropagation();
		
		this.video.play();
	}
	
	onMuteClick = (evt) => {
		evt && evt.stopPropagation();
		
		this.video.muted = true;
	}
	
	onUnMuteClick = (evt) => {
		evt && evt.stopPropagation();
		
		this.video.muted = false;
	}
	
	onVolumeProgressClick = (evt) => {
		const progress = this.getProgressPercentByOffsetWidth({ offset: evt.layerX, width: this.ui.volumeProgress.clientWidth });
		
		if (this.video.muted) this.video.muted = false;
		this.video.volume = progress / 100;
	}
	
	onEnterFullscreenClick = () => {
		const isFullscreenSupport = this.streamView.requestFullscreen || this.streamView.webkitRequestFullscreen || this.streamView.msRequestFullscreen;
		
		if (isFullscreenSupport) {
			this.openFullscreen();
		} else if (this.video.webkitEnterFullScreen) {
			this.video.webkitEnterFullScreen();
		}
	}
	
	onExitFullscreenClick = () => {
		this.closeFullscreen();
	}
	
	onFullscreenModeChanged = () => {
		if (document.fullscreenElement) {
			this.ui.fullscreenContainer.classList.add('vads-fullscreen-open');
			this.ui.fullscreenContainer.classList.remove('vads-fullscreen-closed');
		} else {
			this.ui.fullscreenContainer.classList.remove('vads-fullscreen-open');
			this.ui.fullscreenContainer.classList.add('vads-fullscreen-closed');
		}
	}
	
	openFullscreen = () => { // contentSlot
		if (this.streamView.requestFullscreen) {
			this.streamView.requestFullscreen();
		} else if (this.streamView.webkitRequestFullscreen) {
			this.streamView.webkitRequestFullscreen();
		} else if (this.streamView.msRequestFullscreen) {
			this.streamView.msRequestFullscreen();
		}
	}
	
	closeFullscreen = () => {
		if (!document.fullscreen) return;
		
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		}
	}
	
	onSliderModeClick = (evt) => {
		evt.stopPropagation();
		
		this.closeFullscreen();
		this.streamView.classList.toggle('vads-stream-slider');
		
		this._emitter.emit(event.Player.ResizeAllAds, { width: this._container.clientWidth, height: this._container.clientHeight });
	}
	
	getFormattedCurrentTime = (currentTime) => {
		const minutes = Math.floor(currentTime / 60);
		const seconds = Math.floor(currentTime % 60);
		
		return `${minutes}:${seconds > 9 ? seconds : '0' + seconds}`;
	}
	
	getProgressPercentByOffsetWidth = ({ offset, width }) => offset / (width / 100);
}
